module.exports = __webpack_public_path__ + "static/media/mail-add.7fa51496.svg";